/**
 * Created by pandemio on 9/20/18.
 */
import React from 'react';
import {
    Input,
    Col,
    Button,
    Card,
    CardBody,
    CardHeader,
    Container,
    Row,
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter
} from 'reactstrap';

/** Multiple Language imports **/
import {withLocalize} from "react-localize-redux";
import {renderToStaticMarkup} from 'react-dom/server'; // Fix by the author. Do not remove even if it's not resolved
import {Translate} from "react-localize-redux";
import global from "../translations/global.json"
/** End of Multiple Language imports **/

import ApiCalls from "../custom-classes/api-calls";
import LanguageManager from '../custom-classes/language-manager';
import FormGroupAddress from './forms/form-group-address';
import FormGroupNewPassword from './forms/form-group-new-password';
import NavbarMobile from './navbar/navbar-mobile';
import NavbarDesktop from './navbar/navbar-desktop-top';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faCogs} from '@fortawesome/free-solid-svg-icons';
import Footer from './footer/footer';
import CheckoutForm from './stripe/stripe-card';
import {Elements, StripeProvider} from 'react-stripe-elements';
import Settings from '../custom-classes/settings';
import { Redirect} from "react-router-dom";

/**
 * The component (window), where the user can update her information
 */
class UpdateInformation extends React.Component {

    constructor(props) {
        // Super is always called when defining the constructor of a subclass
        // All React component classes that have a constructor, should start it with a super(props) call.
        super(props);
        // To support language library add the following lines
        this.props.initialize({
            languages: [
                {name: "English", code: "en"},
                {name: "Español", code: "es"}
            ],
            options: {renderToStaticMarkup, defaultLanguage: LanguageManager.getLanguage()}
        });
        this.props.addTranslation(global);

        this.state = {
            oldPassword: '',
            password: '',
            passwordRetype: '',
            addressLine1: '',
            addressLine2: '',
            city: '',
            state: '',
            country: '',
            zipCode: '',
            validAddress: true,
            validCity: true,
            validState: true,
            validCountry: true,
            validZipCode: true,
            proceedSubmitAddress: true,
            proceedSubmitPassword: false,
            showModalTerms: false,
            showModalChildrensPolicy: false,
            checkPolicyAccepted: false,
            checkChildPolicyAccepted: false,
            modalMessage: '',
            modal: false,
            navbarMobile: false,
            subTokenStripe: null,
            stripeApiKey: Settings.getStripeToken(),
            stripeUpdatePayment: true,
            sessionValid: true
        };

        this.saveOldPasswordState = this.saveOldPasswordState.bind(this);
        this.saveNewPassword = this.saveNewPassword.bind(this);
        this.saveNewCardPayment = this.saveNewCardPayment.bind(this);
        this.updateUserMainAddress = this.updateUserMainAddress.bind(this);
        this.setStripePaymentToken = this.setStripePaymentToken.bind(this);
        this.toggle = this.toggle.bind(this);
    }

    componentWillMount() {
        let apiCall = ApiCalls.getUserMainAddress();
        apiCall.then((data)=> {
            this.setState({
                addressLine1: data.UserAddress.AddressLine1,
                addressLine2: '',
                city: data.UserAddress.City,
                state: data.UserAddress.State,
                country: data.UserAddress.CountryIsoCode2, // Default
                zipCode: data.UserAddress.Zip,
                sessionValid: data.SessionValid
            });
        });
    }

    /** Evaluate the resize, to show the proper navbar menu style*/
    componentDidMount() {
        window.addEventListener("resize", this.resize.bind(this));
        this.resize();
    }

    /**
     * Set the stripe payment token
     * @param field
     */
    setStripePaymentToken = (field) => (newValue) =>{

        if(newValue == null)
            this.setState({
                subTokenStripe: null
            });
        else
        {
            this.setState({
                subTokenStripe: newValue.id
            });
        }
    };

    resize() {
        this.setState({navbarMobile: window.screen.width <= 1024});
    }

    /**
     * Hide or shows the message window
     */
    toggle() {
        this.setState({
            modal: !this.state.modal
        });
    }

    /**
     * Saves the old password in the state
     * @param event
     */
    saveOldPasswordState(event) {
        this.setState({oldPassword: event.target.value}, () => {
            this.setSubmitNewPasswordState();
        });
    };

    /**
     * Saves the password state
     * @param field
     */
    savePasswordState = (field) =>(newValue)=> {
        this.setState(
            {
                'password': newValue.password,
                'passwordRetype': newValue.passwordRetype
            }, () => {
                this.setSubmitNewPasswordState();
            });
    };

    /** Save the address **/
    saveAddress = (field) => (newValue) => {
        this.setState(
            {
                'addressLine1': newValue.addressLine1,
                'addressLine2': newValue.addressLine2,
                'city': newValue.city,
                'country': newValue.country,
                'state': newValue.state,
                'zipCode': newValue.zipCode,
                'validAddress': newValue.validAddress,
                'validCity': newValue.validCity,
                'validCountry': newValue.validCountry,
                'validPhone': newValue.validPhone,
                'validState': newValue.validState,
                'validZipCode': newValue.validZipCode,
            }, () => {
                this.setSubmitAddressButtonState();
            });
    };

    /**
     * Set the state of the button to submit the address
     */
    setSubmitNewPasswordState() {
        this.setState({
            proceedSubmitPassword: (
                this.state.oldPassword.length > 5
                && this.state.password.length > 5
                && this.state.passwordRetype.length > 5
            )
        });
    }

    /**
     * Saves the new password in the api call
     */
    saveNewPassword() {

        // Saves the new password
        let apiCall = ApiCalls.insertNewPassword(this.state.oldPassword, this.state.password, this.state.passwordRetype);
        apiCall.then((data)=> {
            this.setState({modalMessage: data.Messages[0], sessionValid: data.SessionValid});
            this.toggle();

        });
    }

    /**
     * Saves the new card payment
     */
    saveNewCardPayment(){
        // Saves the new password
        let apiCall = ApiCalls.insertNewPaymentMethod(this.state.subTokenStripe);
        apiCall.then((data)=> {
            this.setState({modalMessage: data.Messages[0]});
            this.toggle();
        });
    }

    /**
     * Send to the service the new address
     */
    updateUserMainAddress() {

        // Saves the new password
        let apiCall = ApiCalls.updateUserMainAddress(this.state.addressLine1, this.state.addressLine2, this.state.city, this.state.state,
            this.state.country, this.state.country, this.state.zipCode);
        apiCall.then((data)=> {
            this.setState({modalMessage: data.Messages[0]});
            this.toggle();

        });
    }

    /** Sets the submit address button state **/
    setSubmitAddressButtonState() {
        this.setState({
            proceedSubmitAddress: (
                this.state.validAddress
                && this.state.validCity
                && this.state.validCountry
                && this.state.validState
                && this.state.validZipCode
            )
        });
    }

    // Call the item list
    render() {

        if (!this.state.sessionValid)
            return (<Redirect to={{pathname: '/login'}}/>);

        return (
            <div>
                {this.state.navbarMobile ? <NavbarMobile/> : <NavbarDesktop/>}

                <div className="container-padding">
                    <Container className="margin-top-mandatory-60">
                        <h2 className="font-now-bold white-text">
                            <FontAwesomeIcon icon={faCogs}/>{' '}
                            <Translate id="dashboard.settings" options={{renderInnerHtml: false}}/>
                        </h2>
                        <hr/>

                        <Row>
                            <Col sm={{size: 12, offset: 0}} md={{size: 6}} lg={{size: 6}}>
                                <Card className="card-blue-transparency">
                                    <CardHeader>
                                        <h4 className="white-text">
                                            <Translate id="form-updates.edit-your-info"
                                                       options={{renderInnerHtml: true}}/>
                                        </h4>
                                        <small>
                                            <Translate id="form-updates.edit-info-subtitle"
                                                       options={{renderInnerHtml: true}}/>
                                        </small>
                                    </CardHeader>
                                    <CardBody>
                                        <Row>
                                            <Col sm={{size: 12, offset: 0}} lg={{size: 12, offset: 0}}
                                                 md={{size: 12, offset: 0}}>
                                                <FormGroupAddress data={this.state} updateParent={this.saveAddress()}/>
                                            </Col>
                                            <Col sm={{size: 10, offset: 1}} lg={{size: 10, offset: 1}}
                                                 md={{size: 10, offset: 1}}>
                                                <Button block color="success"
                                                        disabled={!this.state.proceedSubmitAddress}
                                                        onClick={this.updateUserMainAddress}>
                                                    <Translate id="general.submit" options={{renderInnerHtml: true}}/>
                                                </Button>
                                            </Col>
                                        </Row>
                                    </CardBody>
                                </Card>
                            </Col>
                            <Col sm={{size: 12, offset: 0}} md={{size: 6}} lg={{size: 6}}>
                                <Card className="card-blue-transparency">
                                    <CardHeader>
                                        <h4 className="white-text">
                                            <Translate id="form-updates.reset-your-password-title"
                                                       options={{renderInnerHtml: true}}/>
                                        </h4>
                                        <small>
                                            <Translate id="form-updates.reset-your-password-subtitle"
                                                       options={{renderInnerHtml: true}}/>
                                        </small>
                                    </CardHeader>
                                    <CardBody>
                                        <Row>
                                            <Col sm={{size: 12, offset: 0}} lg={{size: 12, offset: 0}}
                                                 md={{size: 12, offset: 0}}>
                                                <p>
                                                    <Translate id="form-updates.old-password-instructions"
                                                               options={{renderInnerHtml: true}}/>
                                                </p>
                                                <Input type="password" onChange={this.saveOldPasswordState}/>
                                            </Col>
                                        </Row>
                                        <Row>

                                            <Col sm={{size: 12, offset: 0}} lg={{size: 12, offset: 0}}
                                                 md={{size: 12, offset: 0}}>
                                                <FormGroupNewPassword data={this.state}
                                                                      updateParent={this.savePasswordState()}/>
                                            </Col>
                                            <Col sm={{size: 10, offset: 1}} lg={{size: 10, offset: 1}}
                                                 md={{size: 10, offset: 1}}>
                                                <Button block color="success"
                                                        disabled={!this.state.proceedSubmitPassword}
                                                        onClick={this.saveNewPassword}>
                                                    <Translate id="general.submit"/>
                                                </Button>
                                            </Col>
                                        </Row>
                                    </CardBody>
                                </Card>
                                <br/>
                                <Card className="card-blue-transparency">
                                    <CardHeader>
                                        <h4 className="white-text">
                                            <Translate id="form-updates.update-payment-info"
                                                       options={{renderInnerHtml: true}}/>
                                        </h4>
                                        <small>
                                            <Translate id="form-updates.update-payment-info-subtitle"
                                                       options={{renderInnerHtml: true}}/>
                                        </small>
                                    </CardHeader>
                                    <CardBody>
                                        <Row>
                                            <Col sm={{size: 10, offset: 1}} lg={{size: 10, offset: 1}}
                                                 md={{size: 10, offset: 1}}>
                                                <StripeProvider apiKey={this.state.stripeApiKey}>
                                                    <Elements>
                                                        <CheckoutForm data={this.state.stripeUpdatePayment} updateParent={this.setStripePaymentToken()} />
                                                    </Elements>
                                                </StripeProvider>
                                            </Col>
                                            <Col sm={{size: 10, offset: 1}} lg={{size: 10, offset: 1}}
                                                 md={{size: 10, offset: 1}}>
                                                <Button block color="success" disabled={this.state.subTokenStripe === null}
                                                        onClick={this.saveNewCardPayment}>
                                                    <Translate id="general.submit"/>
                                                </Button>
                                            </Col>
                                        </Row>
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>


                        <Modal isOpen={this.state.modal} toggle={this.toggle} className={this.props.className}>
                            <ModalHeader className="card-orange" toggle={this.toggle}>
                                <Translate id="form-updates.attention" options={{renderInnerHtml: false}}/>
                            </ModalHeader>
                            <ModalBody className="card-white">
                                <p>{this.state.modalMessage}</p>
                            </ModalBody>
                            <ModalFooter className="card-white">
                                <Button onClick={this.toggle} color="info">
                                    <Translate id="subscriptions.close" options={{renderInnerHtml: false}}/>
                                </Button>
                            </ModalFooter>
                        </Modal>

                    </Container>
                </div>
                <Footer/>
            </div>
        )
    };
}

export default withLocalize(UpdateInformation);